import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { EventsMap } from '@noths/polaris-client-next-redux';

import { actions } from 'src/redux/basket/slice';
import { addItemToBasket, updateItemInBasket } from 'src/redux/basket/thunks';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { generateProductFieldObject } from 'src/utils/googleAnalytics';
import { formatIntegerPriceToDecimal } from 'src/utils/price';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [actions.openBasketModal.type]: (state) => {
    const {
      basket: { trackingData },
    } = state;

    if (trackingData) {
      sendGAEvent({
        ecommerce: null,
      });

      sendGAEvent({
        event: 'cart_update',
        eventCategory: 'Product page',
        eventAction: 'Basket state',
        eventLabel: 'Basket contents',
        ecommerce: {
          checkout: {
            basket_id: trackingData.analyticsId,
            total_items_GBP: formatIntegerPriceToDecimal(trackingData.discountedItemsTotal.cents),
            products: trackingData.items.map(({ product, purchasePrice, quantity }) => ({
              product_code: String(product.code),
              quantity: String(quantity),
              price_GBP: formatIntegerPriceToDecimal(purchasePrice.cents / quantity),
            })),
          },
        },
      });
    }
  },
  [addItemToBasket.fulfilled.type]: ({ basket, product }) => {
    sendGAEvent({
      ecommerce: null,
    });

    sendGAEvent({
      event: 'add_to_cart',
      event_action: 'Add to basket',
      event_category: 'Product page',
      event_label: null,
      ecommerce: {
        add: {
          products: [
            generateProductFieldObject({
              product,
              quantity: basket.quantity,
              selectedOptionValues: basket.selectedOptionValues,
            }),
          ],
        },
      },
    });
  },
  [addItemToBasket.rejected.type]: (_, __, action) => {
    const errorMessage =
      (action as ReturnType<typeof addItemToBasket.rejected>).error.message || 'not set';

    sendGAEvent({
      event: 'custom_event',
      event_action: 'Add to Cart Error',
      event_category: 'Product page',
      event_label: errorMessage,
    });
  },
  [updateItemInBasket.rejected.type]: (_, __, action) => {
    const errorMessage =
      (action as ReturnType<typeof updateItemInBasket.rejected>).error.message || 'not set';

    sendGAEvent({
      event: 'custom_event',
      event_action: 'Edit Cart Error',
      event_category: 'Product page',
      event_label: errorMessage,
    });
  },
};
